// extracted by mini-css-extract-plugin
export var bubble = "_2y-0";
export var container = "_2y-3";
export var contrastBorder = "_2y-4";
export var greyOut = "_2y-2";
export var initialsWrapper = "_2y-1";
export var large = "_2y-9";
export var medium = "_2y-8";
export var mediumSmall = "_2y-7";
export var mediumSmallMedium = "_2y-c";
export var micro = "_2y-5";
export var small = "_2y-6";
export var tiny = "_2y-b";
export var xTiny = "_2y-a";